var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type == 'img')?_c('img',{attrs:{"src":_vm.src,"alt":""}}):_vm._e(),(_vm.type == 'pdf')?_c('div',_vm._l((_vm.numPages),function(i){return _c('pdf',{key:i,ref:"pdf",refInFor:true,attrs:{"src":_vm.url,"page":i}})}),1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }